module.exports = __webpack_public_path__ + "static/media/cloudy.1269e58e.jpg";